"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CoreConfigSetup = void 0;
var CoreConfig_1 = require("./CoreConfig");
var CoreConfigSetup = /** @class */ (function () {
    function CoreConfigSetup() {
    }
    CoreConfigSetup.register = function (config) {
        config.registerKey(CoreConfig_1.CoreConfig.logLevel);
        config.registerKey(CoreConfig_1.CoreConfig.buidEnvironment);
        config.registerKey(CoreConfig_1.CoreConfig.defaultNetwork);
        config.registerKey(CoreConfig_1.CoreConfig.product);
        config.registerKey(CoreConfig_1.CoreConfig.maxRetries);
    };
    return CoreConfigSetup;
}());
exports.CoreConfigSetup = CoreConfigSetup;
//# sourceMappingURL=CoreConfigSetup.js.map